(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["afv-mobile-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 767px)');
  const dock = document.querySelector('.mobile-dock');
  const viewport = window.visualViewport;
  let frame = 0;
  const update = () => {
    frame = 0;
    if (dock) {
      const height = `${Math.ceil(dock.offsetHeight)}px`;
      if (root.style.getPropertyValue('--mobile-dock-height') !== height) root.style.setProperty('--mobile-dock-height', height);
    }
    const focus = document.activeElement;
    const editing = focus?.matches('textarea, [contenteditable="true"], input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="hidden"])');
    const keyboardOpen = Boolean(mobile.matches && editing && viewport && viewport.scale <= 1.05 && viewport.height < window.innerHeight * 0.75);
    root.classList.toggle('afv-keyboard-open', keyboardOpen);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  if (dock && 'ResizeObserver' in window) new ResizeObserver(schedule).observe(dock);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  viewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  if (mobile.addEventListener) mobile.addEventListener('change', schedule);
  else mobile.addListener(schedule);
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["afv-pdp-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
  class AFVSizeConfirmation extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.getAttribute('form'));
      if (!this.info || !this.form) return;
      this.confirmed = null;
      this.requested = null;
      this.pending = false;
      this.abort = new AbortController();
      this.restoreSelection();
      const clearFailed = () => { this.pending = false; this.confirmed = null; this.requested = null; this.sync(); };
      this.info.addEventListener('afv:variant-error', clearFailed, { signal: this.abort.signal });
      this.info.addEventListener('afv:cart-error', clearFailed, { signal: this.abort.signal });
      document.addEventListener('ajaxProduct:error', () => {
        if (this.form.querySelector('[name="add"][aria-busy="true"]')) clearFailed();
      }, { signal: this.abort.signal });
      const options = { capture: true, signal: this.abort.signal };
      this.info.addEventListener('change', event => this.selectSize(event), options);
      this.form.addEventListener('variant:change', event => this.resolveSize(event), { signal: this.abort.signal });
      document.addEventListener('submit', event => {
        if (event.target === this.form && (!this.ready() || this.busy())) this.stop(event);
      }, options);
      document.addEventListener('click', event => {
        const control = event.target.closest('button, input[type="submit"], a');
        if (!control || (this.ready() && !this.busy())) return;
        if (control.form === this.form || control.closest('.shopify-payment-button')?.closest('form') === this.form) {
          if (control.matches('[type="submit"], [data-checkout-now]') || control.closest('.shopify-payment-button')) this.stop(event);
        }
      }, options);
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.observer.observe(this.info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'] });
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.restoreSelection();
        this.sync();
        this.scheduleSync();
      }, { signal: this.abort.signal });
      this.sync();
      this.scheduleSync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.started = false;
    }
    sizeGroup() {
      return this.info.querySelector(`variant-picker [data-option-index="${this.dataset.optionIndex}"]`);
    }
    chosenControl(group = this.sizeGroup()) {
      return group?.querySelector('select') || group?.querySelector('input:checked');
    }
    readVariant() {
      try { return JSON.parse(this.info.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { return null; }
    }
    matchesVariant(variant) {
      const groups = this.info.querySelector('variant-picker')?.querySelectorAll('[data-option-index]') || [];
      return [...groups].every(group => {
        const position = Number(group.dataset.optionIndex?.replace('option', '')) - 1;
        const chosen = this.chosenControl(group);
        return chosen && (!chosen.disabled || variant?.available === false) && chosen.value === variant?.options?.[position];
      });
    }
    scheduleSync() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }
    restoreSelection() {
      const params = new URLSearchParams(window.location.search);
      const variant = this.readVariant();
      const linked = params.get('variant') || this.dataset.initialVariant;
      const position = Number(this.sizeGroup()?.dataset.optionIndex?.replace('option', '')) - 1;
      const chosen = this.chosenControl();
      this.pending = false;
      this.confirmed = null;
      this.requested = null;
      if (linked && String(variant?.id) === linked && chosen?.value === variant?.options?.[position] &&
          this.form.querySelector('[name="id"]')?.value === linked && this.matchesVariant(variant)) {
        this.requested = chosen.value;
        this.confirmed = { id: linked, size: chosen.value, available: variant.available, variant };
      }
    }
    busy() {
      return Boolean(this.form.querySelector('[aria-busy="true"]'));
    }
    ready() {
      const chosen = this.chosenControl();
      return Boolean(!this.pending && this.confirmed?.available && chosen && !chosen.disabled &&
        chosen.value === this.confirmed.size &&
        this.form.querySelector('[name="id"]')?.value === this.confirmed.id &&
        String(this.readVariant()?.id) === this.confirmed.id && this.matchesVariant(this.confirmed.variant));
    }
    selectSize(event) {
      const group = this.sizeGroup();
      const picker = this.info.querySelector('variant-picker');
      if (!group || event.target.closest('variant-picker') !== picker || !event.target.matches('input[type="radio"], select') || event.target.disabled) return;
      if (group.contains(event.target)) this.requested = event.target.value;
      if (!this.requested) return;
      this.pending = true;
      this.confirmed = null;
      this.sync();
    }
    resolveSize(event) {
      const variant = event.detail?.variant;
      const group = this.sizeGroup();
      const position = Number(group?.dataset.optionIndex?.replace('option', '')) - 1;
      if (!this.requested || !variant || variant.options?.[position] !== this.requested || !this.matchesVariant(variant)) return;
      this.confirmed = { id: String(variant.id), size: this.requested, available: variant.available, variant };
      this.pending = false;
      this.sync();
    }
    stop(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!this.busy()) {
        const group = this.sizeGroup();
        group?.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        group?.querySelector('select, input:not(:disabled)')?.focus({ preventScroll: true });
      }
    }
    setText(element, value) {
      if (element && element.textContent !== value) element.textContent = value;
    }
    sync() {
      if (!this.form?.isConnected) return;
      this.sticky = document.querySelector(`product-sticky-form[form="${this.form.getAttribute('id')}"]`);
      const group = this.sizeGroup();
      if (!group) return;
      if (!this.requested) {
        const select = group.querySelector('select');
        if (select) {
          select.selectedIndex = -1;
          group.querySelectorAll('option[selected]').forEach(option => option.removeAttribute('selected'));
        }
        group.querySelectorAll('input:checked').forEach(input => { input.checked = false; input.removeAttribute('checked'); });
        this.setText(group.querySelector('.form__label .font-medium'), '');
      }
      const ready = this.ready();
      const soldOut = this.confirmed && !this.confirmed.available;
      this.info.querySelectorAll('[data-afv-size-inventory]').forEach(inventory => {
        const prompt = inventory.querySelector('[data-afv-stock-prompt]');
        const content = inventory.querySelector('[data-afv-stock-content]');
        const awaiting = !this.confirmed || this.pending;
        if (prompt && prompt.hidden === awaiting) prompt.hidden = !awaiting;
        if (content && content.hidden !== awaiting) content.hidden = awaiting;
      });
      const text = ready || soldOut ? `${this.dataset.selected} ${this.confirmed.size}${soldOut ? ` · ${this.dataset.soldOut}` : ''}` : this.pending ? this.dataset.updating : this.dataset.choose;
      this.setText(this.querySelector('[data-size-status]'), text);
      group.querySelectorAll('input[type="radio"]').forEach(input => {
        const label = group.querySelector(`label[for="${input.id}"]`);
        if (!label) return;
        const status = label.querySelector('[data-afv-stock-label]');
        if (input.disabled && label.querySelector('.afv-variant-option__status')) {
          status?.remove();
          input.setAttribute('aria-label', `${input.value} — ${this.dataset.soldOut}`);
          return;
        }
        if (input.disabled && !status) {
          const note = document.createElement('small');
          note.setAttribute('data-afv-stock-label', '');
          note.textContent = this.dataset.soldOut;
          label.append(note);
          input.setAttribute('aria-label', `${input.value} — ${this.dataset.soldOut}`);
        } else if (!input.disabled && status) {
          status.remove();
          input.removeAttribute('aria-label');
        }
      });
      const buttons = [...this.form.querySelectorAll('[type="submit"], [data-checkout-now]'), ...(this.sticky?.querySelectorAll('[type="submit"]') || [])];
      buttons.forEach(button => {
        if (!ready) {
          if (!button.hasAttribute('data-afv-size-lock')) {
            button.dataset.afvSizeOriginal = button.querySelector('.btn-text > span, .btn-text')?.textContent || '';
            button.setAttribute('data-afv-size-lock', '');
          }
          if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
          if (!this.pending && !this.busy()) this.setText(button.querySelector('.btn-text > span, .btn-text'), soldOut ? this.dataset.soldOut : this.dataset.choose);
        } else if (button.hasAttribute('data-afv-size-lock')) {
          if (button.getAttribute('aria-busy') !== 'true') button.removeAttribute('aria-disabled');
          if (!this.busy()) this.setText(button.querySelector('.btn-text > span, .btn-text'), button.matches('[data-checkout-now]') ? button.dataset.afvSizeOriginal : button.hasAttribute('data-pre-order') ? theme.variantStrings.preOrder : theme.variantStrings.addToCart);
          button.removeAttribute('data-afv-size-lock');
        }
        if (this.sticky?.contains(button)) button.setAttribute('aria-label', ready ? button.hasAttribute('data-pre-order') ? theme.variantStrings.preOrder : theme.variantStrings.addToCart : soldOut ? this.dataset.soldOut : this.dataset.choose);
      });
      this.form.querySelectorAll('.shopify-payment-button').forEach(payment => {
        if (payment.hidden === ready) payment.hidden = !ready;
        if (payment.inert !== !ready) payment.inert = !ready;
      });
      const selectedOptions = this.confirmed?.variant.title || this.confirmed?.variant.options?.join(' / ') || this.confirmed?.size;
      this.setText(this.sticky?.querySelector('[data-sticky-product-options]'), selectedOptions || this.dataset.choose);
    }
  }
  if (!customElements.get('afv-size-confirmation')) customElements.define('afv-size-confirmation', AFVSizeConfirmation);
})();
  } catch(e) { console.error(e); }
})();

})();
